module.exports = __webpack_public_path__ + "static/media/select-organization-welcome-student.ac471a21.svg";